import { addQueryParam } from '@change-corgi/core/http';

export function addReason(to: string, reason?: string): string {
	if (!reason) return to;
	return addQueryParam(to, 'redirect_reason', reason);
}
